import { MainBorrowerProfilingState } from "../types";
import { initBorrowerProfilingProcess } from "./async/initBorrowerProfilingProcess";
import { MainBorrowerProfilingAsyncActions, MainBorrowerProfilingSyncActions } from "./types";

const createAsyncActions = (
  actions: MainBorrowerProfilingSyncActions,
  getState: () => MainBorrowerProfilingState
): MainBorrowerProfilingAsyncActions => {
  return {
    initBorrowerProfilingProcessAsync: (borrowerProjectId) => initBorrowerProfilingProcess(borrowerProjectId, actions, getState)
  }
}

export default createAsyncActions
